import Vue from '/vodalys/vvuejs/vue'
import {vVuejsModule} from './vvuejs.parcel.mjs'



// deguelasse but necessary (pour rendre unobservable es instanceScope dans le context vrun )
import {VueNonreactive}  from './.jslibs/'
Vue.use(VueNonreactive)


vVuejsModule.config(['$provide', function ($provide) {


    $provide.decorator('vRunService', [
		'$delegate', '$injector', 'vRunApply', 
		function vRunServiceDecorator($delegate, $injector, vRunApply) {
			console.info('hooking VRUN vRunService for Vue...')

            // console.log($delegate)

			var dispatching = false;
			function dispatchLater()
			{
				if (dispatching)
				{
					return;
				}
				dispatching = true;
				setTimeout(function () {
					dispatching = false; 
					vRunScope.$digest(); 
				}, 0);
			}

			
            const originalregisterInstance = $delegate.registerInstance

			$delegate.registerInstance = function decorateRegisterInstance($scope, handler, id, def) {

				try
					{
						$injector.invoke([def.factory, function (factory) {
							vRunScope.instances[id] = factory(id);
						}]);
					} 
					catch (e)
					{
						console.log('Missing factory ? ', def.factory, def);
						throw e;
					}
					
					var instanceScope;
					if (vRunScope.instances[id]['$id']) // if instance is already a scope, keep it
					{
						instanceScope = vRunScope.instances[id]
					}
					else
					{
						instanceScope = vRunScope.$new(true);
					}
					instanceScope.def = def;

					// the magic appen here
					// https://github.com/vuejs/vue/issues/2637#issuecomment-327153448
					// https://github.com/rpkilby/vue-nonreactive
					Vue.nonreactive(instanceScope)
					
					vRunScope.instances[id]._instanceScope = instanceScope;
					
					angular.forEach(def['fields'], function(index, field_name) 
					{
						var vRunUnapply;

						instanceScope.$watch(function()
						{ 
							return instanceScope.def['fields'][field_name]['value']; 

						}, function(field_def)
						{
							if(vRunUnapply)
							{
								vRunUnapply();
							}

							if (field_def && field_def['#type'] && vRunApply[field_def['#type']])
							{
								vRunUnapply = vRunApply[field_def['#type']](id, field_name, field_def, handler, instanceScope);
							}
							else
							{
								vRunUnapply = vRunApply['default'](id, field_name, field_def, handler, instanceScope);
							}
						});

						dispatchLater();
						
					});

			}

			console.info('hooking VRUN vRunService for Vue... DONE')

			return $delegate

		}])


    $provide.decorator('vodalys_form_service', [
        '$delegate',
        function vodalys_form_serviceDecorator($delegate) {

            console.info('hooking apply_delta for Vue...')

            const originalApply_delta = $delegate.apply_delta

            $delegate.apply_delta = function decorateApplyDelta(component_wrapper, delta) {
                if (!delta) {
                    return;
                }
                if (delta['#deleted']) {
                    for (var key in delta['#deleted']) {
                        key = delta['#deleted'][key];
                        var find = $delegate.find(component_wrapper.component, key);
                        // delete find.parent[find.key];
                        Vue.delete(find.parent, find.key)
                    }
                    delete delta['#deleted'];
                }

                for (var key in delta) {
                    var value = delta[key];
                    if (key == 'root') {
                        // component_wrapper.component = value;
                        Vue.set(component_wrapper, 'component', value)
                    }
                    else {
                        var find = $delegate.find(component_wrapper.component, key);
                        if (find.key % 1 != 0) // ca veut dire : si find.key est n'est pas un nombre
                        {
                            if (jQuery.isArray(find.parent)) {

                            }
                        }
                        // find.parent[find.key] = value;
                        Vue.set(find.parent, find.key, value)
                    }
                }

                // originalApply_delta(component_wrapper, delta)
            }

            
            console.info('hooking apply_delta for Vue... done')

            return $delegate
        }
    ])
}])